// Whether the Student Check-In entry is offered in the navigation.
//
// On by default everywhere. While the feature was being finished it was shown
// only on staging and local hosts; it is now verified end to end and paying
// customers run check-ins, so production shows it too. The build-time flag
// remains the way to switch it off (REACT_APP_STUDENT_CHECKIN_ENABLED=false)
// or force it on, and is baked in at build time like the other REACT_APP_*
// values, so a change needs a rebuild.
export const isStudentCheckInEnabled = ({
  flag = process.env.REACT_APP_STUDENT_CHECKIN_ENABLED,
} = {}) => {
  if (flag === 'false') return false
  return true
}

export default isStudentCheckInEnabled
